import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import Image from 'images/illustrations/Security.svg';
import { H1, Text } from '../Typography';

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${theme.color.neutral[800]};
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(44)};
  justify-items: center;
  width: 100%;

  img {
    width: 100%;
    max-width: ${toRem(400)};
  }
`;

const Messaging = styled.div`
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: ${toRem(500)};
  text-align: center;

  ${H1} {
    color: ${theme.color.white};

    @media (min-width: ${theme.breakpoint.large}px) {
      font-size: ${toRem(33)};
    }
  }

  ${Text} {
    margin-top: ${toRem(11)};
    color: ${theme.color.white};
  }

  button,
  a {
    margin-top: ${toRem(22)};
  }
`;

interface IAuthSecurityItemProps {
  image: string;
  message: string;
  title: string;
}

const AuthSecurityItem = ({ image, message, title }: IAuthSecurityItemProps) => (
  <Layout>
    <Content>
      <img alt="Account Security" src={image} />

      <Messaging>
        <H1>{title}</H1>
        <Text size="default">{message}</Text>
      </Messaging>
    </Content>
  </Layout>
);

const AuthSecurity = () => <AuthSecurityItem image={Image} message="Be sure to keep your recovery pin code and password secure and safe from others." title="Security is a shared responsibility" />;

export default AuthSecurity;
